import { h, defineComponent } from 'vue';
import { PortalCallbacks, portalSection } from '@/services/chargebee/types';
import { t } from '@/ui/i18n/i18n';
import { box, button, pageSubtitle } from '@/ui/components';

export const Invoices = defineComponent({
  name: 'Invoices',
  setup(props, context) {
    const callbacks: PortalCallbacks = {
      loaded: () => {},
      close: () => {},
      visit: (sectionType: string) => {
        // TODO: We can not track invoice download now. Please do it later.
      },
    };

    const showBillingHistory = () => context.emit('click', {
      sectionType: portalSection.BILLING_HISTORY,
      callbacks,
    });

    return function render() {
      return box([
        pageSubtitle(t('subscription.invoices')),
        h('p', { class: 'description' }, t('subscription.invoice-info')),
        button(t('common.edit'), showBillingHistory),
      ]);
    };
  },
});
